import i18n from '@/plugins/i18n'
import actions from './actions'
import getters from './getters'
import mutations from './mutations'
import { BuilderGptModule } from './types'


const BuilderGpt: BuilderGptModule = {
  state: {
    currentStep: 1,
    accessibleStep: 1,
    confirmedSteps: [],
    app:{
      id: null,
      primaryColor:'#11AC86',
      name:'',
      email:'',
      telegram:'',
      botLimit: 5,
      botLimitType: 1,
      emptyChatLogo: null,
      emptyChatMessage: '',
      avatarBlob: null,
      prompts: [i18n.t('builderGpt.step3.advantages.descr.1'), i18n.t('builderGpt.step3.advantages.descr.2')],
      promotionalPage: {
        id: null,
        name: "SupsterGPT"
      },
      currency: '',
      tariffs:[

      ],
      
    },
  },
  actions,
  mutations,
  getters,
  namespaced: true,
}

export default BuilderGpt
